module.exports = __webpack_public_path__ + "img/2.22f8f136.png";